import { useCallback, useEffect, useState } from "react";
export function useProductVariantSelection(initialIds: string[]) {
  const [selectedIds, setSelectedIds] = useState(initialIds);

  useEffect(() => {
    setSelectedIds(initialIds);
  }, [initialIds]);

  const reset = useCallback((ids: string[]) => setSelectedIds(ids), []);
  const toggleAll = useCallback(allIds => {
    setSelectedIds(prev => (prev.length === allIds.length ? [] : allIds));
  }, []);

  return {
    selectedIds,
    setSelectedIds,
    reset,
    toggleAll,
  };
}
